import authManifest from 'store/domains/common/auth.manifest'
import agencyManifest from 'store/domains/common/agency.manifest'
import bankCardsManifest from 'store/domains/common/bank-cards.manifest'
import financeManifest from 'store/domains/common/finance.manifest'
import oauthManifest from 'store/domains/common/oauth.manifest'
import referralManifest from 'store/domains/common/referral.manifest'
import servicesManifest from 'store/domains/common/services.manifest'
import statisticsManifest from 'store/domains/common/statistics.manifest'
import ticketsManifest from 'store/domains/common/tickets.manifest'
import faqManifest from 'store/domains/common/faq.manifest'
import userManifest from 'store/domains/common/user.manifest'

/** Shared domains across products (manifest + i18n namespaces). */
export const commonDomains = {
  auth: {
    manifest: authManifest,
    i18nNamespaces: ['countries'],
  },
  services: {
    manifest: servicesManifest,
    i18nNamespaces: [
      'services',
      'campaigns_editor',
      'banners',
      'industries',
      'media_planner',
      'countries',
      'autoreplenish',
    ],
  },
  statistics: {
    manifest: statisticsManifest,
    i18nNamespaces: ['statistics', 'pulse'],
  },
  finance: {
    manifest: financeManifest,
    i18nNamespaces: [
      'finance',
      'wallets',
      'payment_profiles',
      'invoices',
      'promised_payment',
      'billing',
      'payment_order',
    ],
  },
  'bank-cards': {
    manifest: bankCardsManifest,
    i18nNamespaces: ['bank_cards'],
  },
  referral: {
    manifest: referralManifest,
    i18nNamespaces: ['referral'],
  },
  agency: {
    manifest: agencyManifest,
    i18nNamespaces: ['agency', 'countries'],
  },
  user: {
    manifest: userManifest,
    i18nNamespaces: ['user', 'countries'],
  },
  tickets: {
    manifest: ticketsManifest,
    i18nNamespaces: ['tickets'],
  },
  oauth: {
    manifest: oauthManifest,
    i18nNamespaces: ['oauth'],
  },
  faq: {
    manifest: faqManifest,
    i18nNamespaces: ['faq'],
  },
}
